/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { accountReassignmentSchema } from './account-reassignment';

/** ReadUsersNotificationsInlineResponse — dark-roast DTO: NotificationDao */
export const readUsersNotificationsInlineResponseSchema = z.object({ "accountReassign": z.array(z.lazy(() => accountReassignmentSchema)) });
export type ReadUsersNotificationsInlineResponse = z.infer<typeof readUsersNotificationsInlineResponseSchema>;
